<template>
  <div class="shop-content" ref="element">
    <div class="header-box" ref="header">
      <div class="name">
        采购单号：<p>{{signContractInfo.procurementOrderNo}}</p>
        <a class="copy-number" data-clipboard-action="copy" :data-clipboard-text="signContractInfo.procurementOrderNo" @click="copy">复制</a>
      </div>
      <div class="c999 status" v-if="signContractInfo.procurementStatus==1">未签约</div>
      <div class="corange status" v-if="signContractInfo.procurementStatus==2">已签约</div>
      <div class="cgreen status" v-if="signContractInfo.procurementStatus==3">已完成</div>
      <div class="cred status" v-if="signContractInfo.procurementStatus==4">已关闭</div>
    </div>
    <!-- <div class="goods-box">
      <div class="item">
        <div class="item-img">
          <img src="https://img-gdcdn.ponhu.cn/Fs8yspvh-noRFNCawR3Y947IjyGR">
        </div>
        <div class="content">
          <div class="name">GUCCI/古驰 手提包</div>
          <div class="price">
            <span>采购价：<span class="fz28 fw">8900</span></span> 
          </div>
          <div class="info">
            <span>采购方：胖虎奢侈品 张三 13800138000</span> 
          </div>
        </div>
      </div>
    </div> -->
    <!-- <div class="goods-warp">
      <img :src="order.imgUrl + '?imageView2/1/w/750/h/750'">
      <div class="name">{{order.brandName}} {{order.categoryName}}</div>
      <div class="price">
        <span>成交价：<span class="fz36 fw">{{order.purchasePrice}}</span></span> 
      </div>
      <div class="info">
        <div>采购方：{{order.receiveCompanyName}} {{order.createUser}} {{order.uPhone}}</div>
      </div>
      <div class="btn-box">
        <van-button round type="ponhu" block @click="signcontract" v-if="order.purchaseStatus==1">确认签约</van-button>
        <van-button plain round hairline block type="info" style="margin-top: 20px" @click="mywallet">我的钱包</van-button>
      </div>
    </div> -->
    <!-- 未签约列表 -->
    <div class="goods_list_wrap" :style="{height:contentHeight}">
      <div class="item" v-for="(item,index) in resultInfoData" :key="index" @click="checkList(item,index)">
        <div class="check_box" v-if="item.isUploadLogisticsInfo">
          <img src="https://res.ponhu.cn/redbookRecovery/contract_checkbox_icon_1.png" alt="">
        </div>
        <div class="check_box" v-else-if="signContractInfo.procurementStatus==2">
          <img src="https://res.ponhu.cn/redbookRecovery/contract_checkbox_icon_3.png" alt="" v-if="item.isCheck">
          <img src="https://res.ponhu.cn/redbookRecovery/contract_checkbox_icon_2.png" alt="" v-if="!item.isCheck">
        </div>
        <div class="img">
          <img :src="item.productPic + '?imageView2/1/w/750/h/750'">
        </div>
        <div class="detail">
          <div class="title">{{ item.inventoryName }}</div>
          <p>{{ item.series }}</p>
          <p>{{ item.modelName }}</p>
          <div class="price_wrap">
            <p>采购单价：{{ item.cost }}</p>
            <span>x{{ item.productNum }}</span>
          </div>
        </div>
      </div>

    </div>

    <div class="submit-bar" ref="submitBar" v-if="signContractInfo.procurementStatus==1">
      <div class="sum-box">
        <span style="display: inline-block;">合计：</span>
        <span class="price">{{ signContractInfo.total }}</span>
      </div>
      <button class="footer-btn yellow" @click="signcontract">确认签约</button>
    </div>
    <div class="submit-bar submit_bar_2" ref="submitBar" v-else>
      <button class="footer-btn defalt" @click="mywallet">我的钱包</button>
      <button class="footer-btn yellow" @click="uploadLogistics">上传物流信息</button>
    </div>

    <div class="wrap-login" v-if="loginShow">
      <div class="login-con">
        <div class="close" @click="loginShow=false"></div>
        <div class="login">
          <div class="login-top">
            <p>签约授权</p>
            <div>
              <input type="text" :disabled="true" placeholder="输入手机号" v-model="mobileTxt">
            </div>
            <div class="yzm">
              <input type="text" placeholder="输入验证码" maxLength="6" v-model="loginForm.verificationCode">
              <button class="place" :disabled="disabled" @click="getCode">{{ttext}}</button>
            </div>
            <!-- <div class="operationRule">
              <img src="https://res.ponhu.cn/redbookRecovery/checkboxSelect.png?a=qweqwe" alt="" v-if="knowType" @click="knowType = !knowType">
              <img src="https://res.ponhu.cn/redbookRecovery/checkboxUncheckedImage2.png?a=qweqwe" alt="" v-else @click="knowType = !knowType">
              我已阅读并同意<a href="https://m.ponhu.cn/Ht/privacy.html" hover-class="none">《胖虎奢侈品采购协议》</a>
            </div> -->
          </div>
          <div class="init" @click="login">确认</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ClipboardJS from 'clipboard';
import { validatMobile } from '@/utils/validate'
import { sendVCode, quicklyLogin } from '@/api/login'
import { getPurchaseOrder, purchaseSign, signContract, signContractList } from '@/api/order'
import wxapi from '@/utils/wxApi'

export default {
  data () {
    return {
      procurementNo: '',
      procurementId: null,
      order: {},
      loginForm: {
        mobile: '',
        verificationCode: '',
        channel: 2,
        userSource: 21,
        version: ''
      },
      knowType: false,
      ttext: '获取验证码',
      disabled: false,
      loginShow: false,
      mobileTxt: '',

      contentHeight: '',
      signContractInfo: {},
      resultInfoData: []
    }
  },
  computed: {
    token () {
      return this.$store.getters.token
    }
  },
  created () {
    this.procurementNo = this.$route.params.oid
    wxapi.wxRegister(this.wxRegCallback)
    this.signContractList()
  },
  mounted () {



    //this.$store.dispatch('LoginByUser', '89ac6daf9181eb25f7572726377c0be549f75746')
    //this.$store.dispatch('LoginByUserPhone', '13716365799')
  },
  methods: {
    heightChange () {
      let elementHeight = this.$refs.element.offsetHeight;
      let headerHeight = this.$refs.header.offsetHeight;
      let submitBarHeight = this.$refs.submitBar.offsetHeight;
      console.log(elementHeight, headerHeight, submitBarHeight);
      this.$nextTick(() => {
        this.contentHeight = elementHeight - headerHeight - submitBarHeight + 'px'
      })
    },
    signContractList () {
      signContractList({
        procurementNo: this.procurementNo,
        // pageIndex: 0,
        // pageSize: 0,
        // status: 0
      }).then(res => {
        if (res) {
          console.log(res);
          this.signContractInfo = res
          this.resultInfoData = res.procurementOrderDetail.result
          this.procurementId = res.procurementId
          this.resultInfoData.forEach(item => {
            if (item.isUploadLogisticsInfo) {
              item.isCheck = true
            }
          });
          // this.order = res
          this.loginForm.mobile = res.supplierPhone;
          var reg = /^(\d{3})\d{4}(\d{4})$/;
          this.mobileTxt = res.supplierPhone.replace(reg, "$1****$2");
          // 判断是否是同一个用户
          let userPhone = this.$store.getters.userPhone
          if (userPhone != res.supplierPhone) {
            this.$store.dispatch('LogOut')
            // this.$store.dispatch('LoginByUserPhone', res.supplierPhone)
          }
          this.heightChange()

        } else {
          this.$toast('没有此采购单信息');
        }
      }).catch(err => {
        console.log(err)
        this.$toast(err)
      })
    },
    //复制微信
    copy () {
      let _this = this
      let clipboard = new ClipboardJS('.copy-number');
      clipboard.on('success', function (e) {
        _this.$toast('已经复制到粘贴板！');
        clipboard.destroy();
        e.clearSelection();
      })
      clipboard.on('error', function () {
        _this.$toast('该设备不支持自动复制');
      })
    },
    // 我的钱包
    mywallet () {
      if (this.token) {
        this.$router.push({ name: 'online_purchase_wallet' });
      } else {
        this.loginShow = true;
        this.loginForm.verificationCode = '';
      }
    },
    // 签约
    signcontract () {
      if (this.token) {
        signContract({
          procurementOrderNo: this.signContractInfo.procurementOrderNo,
          userName: this.signContractInfo.supplierPhone
        }).then(res => {
          // if (res) {
          console.log(res);
          this.$toast('签约成功~')
          this.signContractList()
          // this.order = res
          // this.loginForm.mobile = res.supplierPhone;
          // var reg = /^(\d{3})\d{4}(\d{4})$/;
          // this.mobileTxt = res.supplierPhone.replace(reg, "$1****$2");
          // } else {
          //   this.$toast('没有此采购单信息');
          // }
        }).catch(err => {
          console.log(err)
          this.$toast(err)
        })
        // purchaseSign({ purchaseSn: this.orderid, token: this.token }).then(res => {
        //   if (res == '100') { // 签约校验
        //     this.$toast('采购单中供应商信息不匹配，请重新授权');
        //   } else if (res == '209') {
        //     this.$toast('授权过期，请重新授权');
        //     this.loginShow = true;
        //     this.loginForm.verificationCode = '';
        //   } else {
        //     this.$toast('签约成功！')
        //     this.signContract()
        //   }
        // }).catch(err => {
        //   this.$toast(err)
        // })
      } else {
        this.loginShow = true;
        this.loginForm.verificationCode = '';
      }
    },
    //获取验证码
    getCode () {
      if (!validatMobile(this.loginForm.mobile)) {
        this.$toast('请输入正确的手机号')
        return
      }
      let that = this
      let t = 60
      that.ttext = t + '秒后重试'
      that.disabled = true
      var timer = setInterval(function () {
        t--
        if (t > 0) {
          that.ttext = t + '秒后重试'
          that.disabled = true
        } else {
          that.disabled = false
          that.ttext = '获取验证码'
          clearInterval(timer)
        }
      }, 1000)
      sendVCode({ mobile: this.loginForm.mobile }).then(res => {
        console.log(res)
      }).catch(error => {
        this.$toast(error)
      })
    },
    // 登录
    login () {
      if (!validatMobile(this.loginForm.mobile)) {
        this.$toast('请输入正确的手机号')
        return
      }
      if (!this.loginForm.verificationCode) {
        this.$toast('请输入短信验证码')
        return
      }
      quicklyLogin(this.loginForm).then(res => {
        this.loginShow = false
        this.$store.dispatch('LoginByUser', res.userToken)
        this.$store.dispatch('LoginByUserPhone', res.phone)
        this.loginForm.verificationCode = '';
      }).catch(error => {
        console.log(error)
        this.$toast(error)
      })
    },
    // 微信注册
    wxRegCallback () {
      // 微信分享
      this.wxShareTimeline()
      this.wxShareAppMessage()
    },
    wxShareTimeline () {
      let _this = this
      let option = {
        title: '采购签约',
        link: process.env.VUE_APP_ROOT_URL + 'index.html#/online/purchase/contract/' + this.procurementNo,
        imgUrl: 'https://m.ponhu.cn/Public/wap/bing/images/about_ponhu/logo.jpg',
        success: () => {
          _this.$toast('分享成功')
        },
        error: () => {
          _this.$toast('已取消分享')
        }
      }
      // 将配置注入通用方法
      wxapi.ShareTimeline(option)
    },
    wxShareAppMessage () {
      let _this = this
      let option = {
        title: '采购签约',
        desc: '胖虎奢侈品',
        link: process.env.VUE_APP_ROOT_URL + 'index.html#/online/purchase/contract/' + this.procurementNo,
        imgUrl: 'https://m.ponhu.cn/Public/wap/bing/images/about_ponhu/logo.jpg',
        success: () => {
          _this.$toast('分享成功')
        },
        error: () => {
          _this.$toast('已取消分享')
        }
      }
      // 将配置注入通用方法
      wxapi.ShareAppMessage(option)
    },

    // 勾选
    checkList (item, index) {
      if (item.isUploadLogisticsInfo) return false
      item.isCheck = !item.isCheck
      console.log('list', this.resultInfoData);
      this.$set(this.resultInfoData, index, item)
      this.$forceUpdate()
    },
    // 上传物流信息
    uploadLogistics () {
      console.log(this.token);
      if (!this.token) {
        this.loginShow = true;
        this.loginForm.verificationCode = '';
        return false
      }
      let inventoryCode = []
      let uploadArry = []
      this.resultInfoData.forEach(item => {
        if (!item.isUploadLogisticsInfo) {
          if (item.isCheck) {
            inventoryCode.push(item.inventoryCode)
          }
        } else {
          uploadArry.push(item.inventoryCode)
        }
      });
      if (uploadArry.length == this.resultInfoData.length) {
        this.$toast('物流信息已全部上传')
        return false
      }
      if (inventoryCode.length < 1) {
        this.$toast('请先勾选~')
        return false
      }

      this.$router.push({
        // name: 'online_purchase_logistics',
        path: '/online/purchase/logistics',
        query: {
          procurementOrderNo: this.signContractInfo.procurementOrderNo,
          procurementStatus: this.signContractInfo.procurementStatus,
          procurementId: this.procurementId,
          inventoryCode: inventoryCode
        }
      })
    }
  }

}
</script>

<style lang="less" scoped>
.shop-content {
  background-color: #ffffff;
  height: 100vh;
}
.header-box {
  display: flex;
  justify-content: space-between;
  // position: fixed;
  // top: 0;
  // left: 0;
  width: 100%;
  box-sizing: border-box;
  padding: 0rem 0.24rem;
  // height: 0.6rem;
  line-height: 0.6rem;
  border-bottom: 1px solid #e6e7e9;
  background-color: #ffffff;
  height: 1.1rem;
  align-items: center;
  .name {
    font-size: 0.36rem;
    color: #282828;
    display: flex;
    align-items: center;
    p {
      margin: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 55%;
    }
  }
  .status {
    font-size: 0.36rem;
    font-weight: 500;
  }
  .copy-number {
    width: 1rem;
    height: 24px;
    font-size: 0.24rem;
    line-height: 23px;
    text-align: center;
    border-radius: 24px;
    padding: 0.06rem 0.1rem 0;
    margin-left: 0.2rem;
    display: inline-block;
    border: 1px solid rgba(0, 0, 0, 0.2);
  }
}
.goods-warp {
  display: flex;
  justify-content: center;
  padding-top: 60px;
  overflow: hidden;
  position: relative;
  flex-direction: column;
  align-items: center;
  color: #fff;
  font-weight: 400;
  img {
    width: 7.5rem;
    height: 7.5rem;
    vertical-align: top;
  }
  .name {
    margin-top: 24px;
    font-size: 32px;
    font-weight: 500;
    color: #333333;
    line-height: 40px;
  }
  .price {
    font-size: 28px;
    font-weight: 400;
    color: #333333;
    line-height: 40px;
    margin-top: 10px;
  }
  .info {
    font-size: 28px;
    font-weight: 400;
    color: #333333;
    line-height: 40px;
    margin-top: 10px;
  }
  .btn-box {
    margin-top: 60px;
    width: 600px;
  }
}
.goods-box {
  position: relative;
  left: 0;
  width: auto;
  flex: 1;
  .item {
    display: -webkit-box;
    display: -webkit-flex;
    position: relative;
    padding: 0.24rem;
    background-color: #ffffff;
    border-bottom: 1px solid #ebedf0;
    .item-img {
      margin-right: 0.24rem;
      width: 148px;
      height: 148px;
      text-align: center;
      img {
        width: 100%;
        height: 100%;
        vertical-align: top;
      }
    }
    .content {
      webkit-box-flex: 1;
      -webkit-flex: 1;
      flex: 1;
      min-width: 0;
      .name {
        font-size: 28px;
        font-weight: 500;
        color: #333333;
        line-height: 40px;
      }
      .price {
        font-size: 24px;
        font-weight: 400;
        color: #333333;
        line-height: 40px;
        margin-top: 1rem;
        margin-top: 0.2rem;
      }
      .info {
        font-size: 24px;
        font-weight: 400;
        color: #333333;
        line-height: 40px;
        margin-top: 0.2rem;
      }
    }
  }
}
.submit-bar {
  // position: fixed;
  // bottom: 0;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  text-align: right;
  background-color: #fff;
  height: 88px;
  padding-left: 24px;
  font-size: 0.36rem;
  font-weight: 500;
  border-top: 1px solid #ebedf0;
  .sum-box {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    padding-right: 24px;
    color: #333333;
    text-align: left;
    width: 40%;
    .price {
      font-size: 30px;
      font-weight: 500;
    }
    .price::before {
      content: "\00A5";
      margin-right: 1px;
      font-size: 24px;
    }
  }
}
.separator-box {
  padding: 0px 90px;
  height: 115px;
}
.footer-btn {
  height: 88px;
  font-size: 0.36rem;
  font-weight: 500;
  color: #282828;
  line-height: 0.32rem;
}
.defalt {
  width: 180px;
  background: #ffffff;
  border-top: none;
  // border-left: 1px solid #ebedf0;
  border-right: none;
  border-bottom: none;
}
.yellow {
  width: 300px;
  background: #ffd133;
  border: 0;
}
button::after {
  border: 0;
  border-radius: 0;
}
.wrap-login {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.7);
  .login-con {
    width: 582px;
    height: 638px;
    position: absolute;
    top: 19.5%;
    left: 50%;
    transform: translateX(-50%);
    .close {
      width: 57px;
      height: 81px;
      background: url("../../../assets/img/close.png");
      background-size: 100%;
      position: absolute;
      right: 0;
      top: 0;
    }
    .login {
      width: 582px;
      height: 557px;
      background: white;
      border-radius: 12px;
      position: absolute;
      bottom: 0;
      left: 0;
      .login-top {
        width: 513px;
        height: 316px;
        margin: 44px auto;
        p {
          font-size: 32px;
          font-weight: 700;
          color: #333333;
          line-height: 40px;
          text-align: center;
        }
        p:nth-child(2) {
          font-size: 28px;
          font-weight: 400;
          color: #282828;
          line-height: 40px;
          margin-top: 19px;
        }
        input {
          width: 490px;
          height: 89px;
          text-align: left;
          background: #f7f7f7;
          font-size: 0.28rem;
          font-weight: 400;
          color: #282828;
          outline: none;
          border: none;
          padding: 0 0 0 0.25rem;
          border-radius: 0.12rem;
          position: absolute;
          top: 130px;
        }
        .yzm {
          border-radius: 0.12rem;
          color: #282828;
          font-weight: 400;
          outline: none;
          border: none;
          position: absolute;
          input {
            width: 280px;
            height: 89px;
            border-radius: 0.12rem;
            padding: 0 0 0 0.25rem;
            margin-top: 0;
          }
          .place {
            width: 196px;
            height: 89px;
            padding: 0;
            border-radius: 0.12rem;
            border: 1px solid #ffd133;
            color: #ffd133;
            background-color: #ffffff;
            float: right;
            text-align: center;
            line-height: 89px;
            font-size: 28px;
            position: absolute;
            left: 310px;
            top: 130px;
          }
        }
      }
      .init {
        width: 100%;
        height: 88px;
        background: #ffd133;
        color: #282828;
        font-size: 28px;
        line-height: 88px;
        color: rgba(40, 40, 40, 1);
        text-align: center;
        position: absolute;
        bottom: 0;
        border-bottom-left-radius: 0.12rem;
        border-bottom-right-radius: 0.12rem;
      }
    }
  }
}
.operationRule {
  color: #222;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 150px;
  img {
    width: 28px;
    height: 28px;
    margin-right: 11px;
  }
  a {
    color: #6473f8;
    font-weight: 500;
  }
}
.van-button--plain.van-button--info {
  border: 1px solid #282828;
}
// 未签约列表
.goods_list_wrap {
  padding: 0 0.24rem;
  overflow-y: auto;
  .item {
    padding: 0.2rem 0;
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba(83, 83, 83, 0.2);
    .check_box {
      flex: 0 0 0.6rem;
      img {
        display: block;
        width: 0.4rem;
        height: 0.4rem;
      }
    }
    .img {
      flex: 0 0 3rem;
      height: 3rem;
      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
    .detail {
      flex: 1;
      box-sizing: border-box;
      padding-left: 0.5rem;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      .title {
        font-size: 0.36rem;
        font-weight: 500;
        color: #282828;
        padding-bottom: 0.2rem;
        width: 100%;
        overflow: hidden; /*超出部分隐藏*/
        white-space: nowrap; /*不换行*/
        text-overflow: ellipsis; /*超出部分文字以...显示*/
      }
      p {
        font-size: 0.34rem;
        // font-weight: 300;
        color: #282828;
        padding-bottom: 0.2rem;
        margin: 0;
      }
      .price_wrap {
        display: flex;
        align-items: center;
        justify-content: space-between;
        p {
          padding-bottom: 0;
        }
        span {
          display: block;
          height: 0.5rem;
          border: 1px solid rgba(83, 83, 83, 0.5);
          text-align: center;
          line-height: 0.5rem;
          font-size: 0.34rem;
          font-weight: 300;
          color: #282828;
          border-radius: 0.1rem;
        }
      }
    }
  }
}

.submit_bar_2 {
  padding: 0;
  .footer-btn {
    flex: 1;
    border: 0;
  }
}
</style>


